/**
 * Calculates the converted duct leakage value.
 *
 * @param cfm25 (number or null)
 * @param dfaa (number or null)
 * @returns number | null
 */
export function calculateConvertedDuctLeakage(
    cfm25: number | null | undefined,
    dfaa: number | null | undefined,
): number | null {
    // If any value is missing or zero, return null to avoid division by zero
    if (!cfm25 || !dfaa || dfaa === 0) return null

    // Calculate and round to two decimals
    return Math.round((cfm25 / dfaa) * 100 * 100) / 100
}
